import {GridBox} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const NotesContainer = styled(GridBox, {
	gap: 20,
	gridTemplateColumns: 'auto 1fr',
});
